import { render, staticRenderFns } from "./TermMultibarChart.vue?vue&type=template&id=1aa9287c&scoped=true&"
import script from "./TermMultibarChart.vue?vue&type=script&lang=js&"
export * from "./TermMultibarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9287c",
  null
  
)

export default component.exports